import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function RoomGuideSkeleton() {
    return (
        <div className="roomguide-content">
            <div className="roomguide-image">
                <Skeleton height={300} borderRadius={14} />
            </div>

            <div className="roomguide-text">
                <Skeleton width="55%" height={24} />
                <Skeleton count={2} style={{ marginTop: 10 }} />

                <Skeleton
                    width="40%"
                    height={20}
                    style={{ marginTop: 16 }}
                />

                <Skeleton height={160} style={{ marginTop: 14 }} />

                <Skeleton
                    width={170}
                    height={44}
                    style={{ marginTop: 24 }}
                />
            </div>
        </div>
    );
}
